import React from "react";
import "./promo.scss";
import penawaran from "../../Media/Hardsell.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";

const Penawaran = () => {
  const Cherrywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282386303140&text=Halo%20Mario,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Jakarta%20Garden%20City%20(Promo)%20https://marketingjakartagardencity.id/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div id="promo" className="promosumbog">
      <div className="promo-sumbog">
        <div className="gambarpromo">
          <img src={penawaran} alt={penawaran} />
        </div>
        <div className="ket-promo">
          <div className="judul">
            <h1>Promo The Mutiara Bogor</h1>
          </div>
          <div className="promolist">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>&nbsp;&nbsp;Free AC</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>&nbsp;&nbsp;Free Canopy</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Free Smartdoor Lock
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Free Smarthome System
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>&nbsp;&nbsp;Free TV*</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>&nbsp;&nbsp;Free Iphone 17*</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Free Refrigerator*
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Free Vacuum Cleaner*
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Penawaran;
